class DeviceProductForm extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    if (!this.initialized) {
      this.init()
      this.initialized = true
    }
  }

  init() {
    console.log('init')
    try {
      this.setupAddToCart()
      this.setupPriceUpdating()
    } catch (error) {
      console.error('Error initializing DeviceProductForm:', error)
    }
  }

  setupAddToCart() {
    console.log('setupAddToCart')
    const $$addToCartButtons = document.querySelectorAll('[data-add-to-cart]')

    $$addToCartButtons.forEach(($addToCartButton) =>
      $addToCartButton.addEventListener('click', () => {
        $addToCartButton.dataset.loading = null

        const addToCartPayload = this.buildAddToCartPayload()

        // Check if upsell modal should be triggered
        if (this.shouldTriggerUpsellModal(addToCartPayload)) {
          const upgradeMapping = this.getUpgradeMapping()
          if (upgradeMapping) {
            // Emit event to show upsell modal
            const upsellEvent = new CustomEvent('device-form:show-upsell', {
              detail: { addToCartData: addToCartPayload, upgradeMapping: upgradeMapping, button: $addToCartButton },
            })
            document.dispatchEvent(upsellEvent)
            return // Don't proceed with ATC yet
          }
        }

        // Proceed with normal add to cart
        this.executeAddToCart(addToCartPayload, $addToCartButton)
      })
    )

    const $deviceOnlyRadio = this.querySelector('#device-only')
    if ($deviceOnlyRadio) {
      $deviceOnlyRadio.addEventListener('change', (e) => {
        if (e.target && e.target.checked) {
          document.dispatchEvent(new CustomEvent('device-form:device-only-selected'))
        }
      })
    }
    // When upgrade radio is selected, emit event to switch gallery slide
    const $upgradeRadio = this.querySelector('#product-upgrade-radio')
    if ($upgradeRadio) {
      $upgradeRadio.addEventListener('change', (e) => {
        if (e.target && e.target.checked) {
          document.dispatchEvent(new CustomEvent('device-form:upgrade-selected'))
        }
      })
    }
  }

  buildAddToCartPayload() {
    const addToCartPayload = { items: [] }

    // Add main product to cart
    addToCartPayload.items.unshift({ quantity: 1, id: Number(this.getAttribute('variant-id')) })

    // Check if product upgrade is selected
    const $productUpgrade = this.querySelector('[name="product-upgrade"]:checked')
    if ($productUpgrade && $productUpgrade.value != '') {
      addToCartPayload.items.unshift({ quantity: 1, id: Number($productUpgrade.value), properties: { _upgrade: true } })
      if (window.posthog) {
        window.posthog.capture('product-upgrade:upgrade_accepted', { source: 'pdp' })
      }
    } else {
      if (window.posthog) {
        window.posthog.capture('product-upgrade:upgrade_declined', { source: 'pdp' })
      }
    }

    const $warranty = this.querySelector('[name="warranty"]:checked')
    if ($warranty && $warranty.value != '') {
      addToCartPayload.items.unshift({ quantity: 1, id: Number($warranty.value) })
    }

    const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
    $$addons.forEach(($addon) => {
      if ($addon.value == '') return
      addToCartPayload.items.push({ quantity: 1, id: Number($addon.value), properties: { _addon: true } })
    })

    try {
      const autoAddons = JSON.parse(this.getAttribute('auto-addons'))
      autoAddons.forEach((addon) => {
        addToCartPayload.items.unshift(addon)
      })
    } catch (error) {
      console.error('Error parsing autoAddons:', error)
    }

    return addToCartPayload
  }

  executeAddToCart(addToCartPayload, $addToCartButton) {
    const warrantyIds = [40117523873827, 40117526167587, 40117524463651, 40559546564643, 40559548858403, 40559546630179]
    const hasWarranty = addToCartPayload.items.some((item) => warrantyIds.includes(item.id))

    // Send PostHog event for add to cart
    const mainProductItem = addToCartPayload.items.find((item) => {
      const deviceVariantId = Number(this.getAttribute('variant-id'))
      return item.id === deviceVariantId
    })

    if (mainProductItem && window.posthog) {
      const hasUpgrade = this.querySelector('[name="product-upgrade"]:checked')?.value !== ''
      const upgradeItems = addToCartPayload.items.filter((item) => item.properties?._upgrade)
      const addonItems = addToCartPayload.items.filter((item) => item.properties?._addon)

      window.posthog.capture('device_add_to_cart', {
        variant_id: mainProductItem.id,
        variant_type: 'device_only',
        has_upgrade: hasUpgrade,
        upgrade_variant_ids: upgradeItems.map((item) => item.id),
        has_addons: addonItems.length > 0,
        addon_count: addonItems.length,
        addon_variant_ids: addonItems.map((item) => item.id),
        has_warranty: hasWarranty,
      })
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(addToCartPayload),
    })
      .then(async (response) => {
        if (!response.ok) {
          const error = await response.json()
          return alert(error.description || error.message)
        }

        if (hasWarranty) window.igEvents.push({ event: 'warranty-added-to-cart' })
        window.NSHybridCart.open()
      })
      .catch((response) => {
        console.error('Error adding to cart:', response)
      })
      .finally(() => {
        delete $addToCartButton.dataset.loading
      })
  }

  shouldTriggerUpsellModal(addToCartPayload) {
    // Check if upsell modal exists and is configured
    if (!window.PreCartUpsellModal || !window.PreCartUpsellModal.config) {
      return false
    }

    const baseProductVariants = window.PreCartUpsellModal.config.productData.baseProduct.variants
    const triggerVariantId = window.PreCartUpsellModal.triggerVariantId

    // If trigger variant ID is set, check against that specific variant
    if (triggerVariantId && triggerVariantId.trim() !== '') {
      return addToCartPayload.items.some((item) => item.id.toString() === triggerVariantId.toString())
    }

    // If no trigger variant ID is set, check if any payload variants match any baseProduct variants
    if (!baseProductVariants || !Array.isArray(baseProductVariants)) {
      return false
    }

    const baseProductVariantIds = baseProductVariants.map((variant) => variant.id.toString())
    return addToCartPayload.items.some((item) => baseProductVariantIds.includes(item.id.toString()))
  }

  getUpgradeMapping() {
    if (!window.PreCartUpsellModal || !window.PreCartUpsellModal.config) {
      return null
    }

    const config = window.PreCartUpsellModal.config
    const settings = config.settings

    // Check if upgrade mapping is configured
    if (!settings.upgrade_product) {
      console.error('[Pre-Cart Modal] No upgrade product configured')
      return null
    }

    // Get product data from the modal config
    const productData = config.productData || {}
    const upgradeProduct = productData.upgradeProduct
    const baseProduct = productData.baseProduct

    if (!upgradeProduct) {
      console.error('[Pre-Cart Modal] No upgrade product data found in modal config')
      return null
    }

    // Get the variant ID - use specified variant ID or first variant
    let upgradeVariantId = settings.upgrade_variant_id
    if (!upgradeVariantId && upgradeProduct.variants && upgradeProduct.variants.length > 0) {
      upgradeVariantId = upgradeProduct.variants[0].id
    }

    // Get base product variant ID if specified
    let baseVariantId = settings.base_variant_id
    if (!baseVariantId && baseProduct && baseProduct.variants && baseProduct.variants.length > 0) {
      baseVariantId = baseProduct.variants[0].id
    }

    const mapping = {
      baseProduct: { productHandle: settings.base_product, variantId: baseVariantId },
      upgradeProduct: { productHandle: settings.upgrade_product, variantId: upgradeVariantId },
      priceDifferenceText: settings.price_difference_text,
    }

    return mapping
  }

  setupPriceUpdating() {
    const $productVariantsData = this.querySelector('#product-variants-data')
    if (!$productVariantsData) {
      console.error('Product variants data element not found')
      return
    }

    const productVariants = JSON.parse($productVariantsData.innerHTML)
    const automaticDiscount = Number(this.getAttribute('automatic-discount'))

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      trailingZeroDisplay: 'stripIfInteger',
    })

    const updatePrice = () => {
      // const $productUpgrade = this.querySelector('[name="product-upgrade"]:checked')
      const $warranty = this.querySelector('[name="warranty"]:checked')
      const $$addons = this.querySelectorAll('[name="addon-product"]:checked')
      const tagsEl = this.querySelector('#product-tags')
      const isTotalValueProduct = tagsEl?.textContent?.includes('Total Value Product') || false
      const $$promoTexts = this.querySelectorAll('[data-promo-text]')
      let displayPrice = 0
      let displayCompareAtPrice = 0
      let totalPrice = 0

      // Use base product variant for device only
      let baseVariant = productVariants[0]
      const baseOriginal = parseInt(baseVariant.compare_at_price || baseVariant.price) || 0
      displayPrice = (parseInt(baseVariant.price) || 0) - automaticDiscount
      displayCompareAtPrice = baseOriginal
      totalPrice = displayPrice

      // Add warranty price to total
      if ($warranty && $warranty.value != '') {
        totalPrice += parseInt($warranty.dataset.price) || 0
      }

      // Add addon prices to total
      $$addons.forEach(($addon) => {
        if ($addon.value == '') return
        totalPrice += parseInt($addon.dataset.price) || 0
      })

      const $$price = this.querySelectorAll('[data-main-product-price]')
      const $$compareAtPrice = this.querySelectorAll('[data-main-product-compare-at-price]')

      const formattedDisplayPrice = formatter.format(displayPrice / 100)

      $$price.forEach(($price) => {
        $price.innerHTML = formattedDisplayPrice
      })

      if (displayCompareAtPrice > displayPrice) {
        const formattedCompareAtPrice = formatter.format(displayCompareAtPrice / 100)
        $$compareAtPrice.forEach(($compareAtPrice) => {
          $compareAtPrice.innerHTML = isTotalValueProduct
            ? `(Total Value ${formattedCompareAtPrice})`
            : formattedCompareAtPrice
          $compareAtPrice.classList.remove('hidden')
        })
        if ($$promoTexts.length > 0) {
          const formattedPriceDifference = formatter.format((displayCompareAtPrice - displayPrice) / 100)
          $$promoTexts.forEach(($promoText) => {
            let currentText = $promoText.textContent
            if (currentText.length === 0) {
              const $promoOriginalText = document.querySelector('[data-promo-original-text]')
              if ($promoOriginalText) {
                currentText = $promoOriginalText.dataset.promoOriginalText
              }
            }
            // Replace just the $ ammount
            $promoText.textContent = currentText.replace(/\$[\d,]+(?:\.\d{2})?/, formattedPriceDifference)
          })
        }
      } else {
        $$compareAtPrice.forEach(($compareAtPrice) => $compareAtPrice.classList.add('hidden'))
      }

      // Update sticky ATC mirrors outside the component
      document.querySelectorAll('[data-main-product-price]').forEach((el) => {
        el.textContent = formattedDisplayPrice
      })

      document.querySelectorAll('[data-main-product-compare-at-price]').forEach((el) => {
        if (displayCompareAtPrice > displayPrice) {
          // Preserve inner structure (sr-only/span/parentheses) by replacing only the $ amount
          const formattedCompareAt = formatter.format(displayCompareAtPrice / 100)
          el.classList.remove('hidden')
          if (/\(\s*Total Value/.test(el.innerHTML)) {
            // Replace entire parenthetical to be robust regardless of currency symbol
            el.innerHTML = el.innerHTML.replace(
              /\(\s*Total Value(?:&nbsp;|\s)*.*?\)/,
              `(Total Value&nbsp;${formattedCompareAt})`
            )
          } else if (/\$[\d,]+(?:\.\d{2})?/.test(el.innerHTML)) {
            el.innerHTML = el.innerHTML.replace(/\$[\d,]+(?:\.\d{2})?/, formattedCompareAt)
          } else {
            // Fallback
            el.textContent = formattedCompareAt
          }
        } else {
          el.classList.add('hidden')
        }
      })

      // Update sticky promo text mirrors
      const formattedPriceDifference = formatter.format((displayCompareAtPrice - displayPrice) / 100)
      document
        .querySelectorAll('#pdp-sticky-nav [data-promo-text], #pdp-mobile-cta [data-promo-text]')
        .forEach((el) => {
          let currentText = el.textContent || ''
          if (!currentText.trim()) {
            // Try to pull original from the main promo text definition
            const mainPromo = document.querySelector('[id^="MainProduct"] [data-promo-text]')
            if (mainPromo && mainPromo.dataset && mainPromo.dataset.promoOriginalText) {
              currentText = mainPromo.dataset.promoOriginalText
            }
          }
          if (currentText && /\$[\d,]+(?:\.\d{2})?/.test(currentText)) {
            el.textContent = currentText.replace(/\$[\d,]+(?:\.\d{2})?/, formattedPriceDifference)
          }
        })

      // TEST - Update promo text
      function updatePromoText() {
        if (window.IG_TEST_PERCENT) {
          const $$promoText = this.querySelectorAll('[data-promo-text]')
          $$promoText.forEach(($promoText) => {
            if ($promoText.textContent.trim() == '') return

            let originalText
            if ($promoText.dataset.originalText) originalText = $promoText.dataset.originalText
            else $promoText.dataset.originalText = $promoText.textContent

            const priceMatch = $promoText.dataset.originalText.match(/\$([\d,.]+)/)
            if (priceMatch) $promoText.dataset.price = priceMatch[1]

            $promoText.dataset.price = parseFloat($promoText.dataset.price?.replace(',', ''))

            const percentOff = ($promoText.dataset.price / (displayCompareAtPrice / 100)) * 100

            $promoText.textContent = `${$promoText.dataset.originalText.replace(/\$([\d,.]+)/, `${percentOff.toFixed(0)}%`)}`

            $promoText.dataset.loaded = true
          })
        }
      }

      if (!window.igData) {
        window.addEventListener('ig:ready', updatePromoText.bind(this))
      } else {
        updatePromoText.call(this)
      }

      // Update Affirm amount
      // const $$affirmElements = this.querySelectorAll('.affirm-as-low-as')
      // $$affirmElements.forEach(($affirm) => {
      //   const affirmDiscount = parseInt($affirm.dataset.affirmDiscount) || 0
      //   $affirm.dataset.amount = displayPrice - affirmDiscount
      // })
    }

    // Ensure we're binding to the correct elements within this component
    const $$selectors = this.querySelectorAll('[name="product-upgrade"], [name="warranty"], [name="addon-product"]')

    // Add event listeners for each selector
    $$selectors.forEach(($selector) => {
      $selector.addEventListener('change', (e) => {
        updatePrice()
      })

      // Also listen for click events on radio buttons to ensure they trigger
      if ($selector.type === 'radio') {
        $selector.addEventListener('click', (e) => {
          updatePrice()
        })
      }
    })

    // Initialize price on page load
    updatePrice()
  }
}

// Ensure the custom element is defined only once
if (!customElements.get('device-product-form')) {
  customElements.define('device-product-form', DeviceProductForm)
} else {
  console.log('DeviceProductForm custom element already defined')
}